import { jsx as e } from "react/jsx-runtime";
import { Popover as l } from "antd";
const r = (o) => /* @__PURE__ */ e(l, { ...o, overlayStyle: {
  ...o.style,
  maxWidth: o.size === "small" ? 450 : 785
}, children: o.children });
export {
  r as TooltipPopover
};
//# sourceMappingURL=TooltipPopover.js.map
